import React from "react";
import CustomSwitchToggle from "../../common/Switch";
import { GetImages } from "../../../utils/GetImages";
import CustomTooltip from "../../common/CustomTooltip";

const QuestionOptional: React.FC<any> = ({
  data,
  postData,
  activeSection
}) => {

  return (
    <>
      <section className="application-sidebar">
        <div className="application-sidebar-head">
          <p className="heading black">Application Sections</p>
          <p className="normal_text black"><i>Customize your experience with toggle buttons </i></p>
        </div>
        <div className="application-sidebar-menu">
          {data?.map((item, i) => {

            const sectionKey = item.name.replace(/\s+/g, "");
            const isSignature = sectionKey === "Signature";
            const isActive = isSignature
              ? !!postData?.leaseApplicationTemplateSections?.Signature?.clause
              : !!postData?.leaseApplicationTemplateSections?.[sectionKey];
            return (
              <div key={i} className={activeSection === sectionKey ? `active application-sidebar-item` : "application-sidebar-item"} >
                  <div className="application-sidebar-item-action">
                    
                  <CustomTooltip
  content={
    sectionKey === "Signature"
      ? "Signature section cannot be toggled"
      : ""
  }
   disabled={sectionKey !== "Signature"}
>
  <div>
    <CustomSwitchToggle
      checked={isActive}
      onClick={(e) => {
        if (sectionKey === "Signature") {
          e.preventDefault();
          return;
        }
        item.onClick();
      }}
    />
  </div>
</CustomTooltip>
                <p className={`normal_text fw-600 ${isActive ? "greyHeading" : "grey"}`}>
                  {item.name}
                </p>
                </div>
                {/* <div className="application-sidebar-item-action"> */}
                  {item?.editable && (() => {
                    return isActive ? (
                      <img
                        onClick={item.editClick}
                        src={GetImages.BlackChevronRight}
                        alt="pencil-outline"
                        className="Icon20 color-white-icon"
                      />
                    ) : (
                      <img
                        onClick={undefined}
                        src={GetImages.BlackChevronRight}
                        alt="pencil-outline"
                        className="Icon20 color-white-icon"
                      />
                    );
                  })()}

                  {/* <CustomSwitchToggle
                    checked={isActive}
                    onClick={item.onClick}
                  /> */}
                  {/* disabled={!postData?.leaseApplicationTemplateSections[item.name.replace(/\s+/g, "")] ? true : false} */}
                  {/* <img src={GetImages.InfoIcon} className="Icon30" alt="info" />{" "} */}
                {/* </div> */}
              </div>
            )
          })}
          <div className="application-sidebar-item emptydiv"> </div>
        </div>
      </section>
    </>
  );
};

export default QuestionOptional;
